var _linearGradient, _linearGradient2, _path, _path2, _path3, _path4, _g, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMidori(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-11 -10 495 495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 337.1,
    x2: 365.9,
    y1: 424.2,
    y2: 442.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e9a06",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 355.3,
    x2: 330.8,
    y1: 456.1,
    y2: 414.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41a100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c5f199",
    d: "M408.3 17.6c-55 30.7-269.8-1-361.2 228.5-12.4 61-6 144.5 52.8 148 12 1 23 9 28.8 18.6 37.4 61 91.3 55.6 113.7 26.5 4.3-5.6 12.5-4 18.3.5 67.4 51.8 112.7-30.3 135.7-94.6 9-28.3 55.2-249 37-272.5-5.4-7-29 13.3-49.8 35-165 173.3-274.6 44 19-85.3l4.5-5.2 3 1.3M182 435l39.5-139.6m-134.2 75l23-81.3M296.6 430l23-81.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#73d216",
    d: "M415.5 108.2c-70 81.7-207.2 145-219 75-5.6-34.4 35-81.6 105.2-128.2C221 77.8 74.7 149 63 261.8c-17 43.4-5.8 136 46.7 121.6 14-3.8 31.2 12.3 35 26.6 8 30.4 65.8 38.5 82.6 25.3a45.2 45.2 0 0146.8-4c60.5 33 89-52 98.7-86 54.3-119.5 31.4-190.4 43-237zM296.6 429.6l23-81.4M182 435l39.5-139.6m-134.2 75l23-81.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M329.5 447.6c2.7-5.3 7.7-5.3 16.5-2.5 5.9 0 13.7-5.5 18.1-10.4 1 19.2-7.5 38.5-15.1 31-1-1-1.8 0-3.3 1-1.5.8-2.2.9-3.7.5-5.1.3-6.1-8-8.4-6.3-4.3 3.2-5.9-5.8-4-13.3z",
    transform: "matrix(10 0 0 10 -3227.7 -4233.9)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c5f199",
    strokeLinecap: "round",
    strokeWidth: 36,
    d: "M117.7 389c-3.3-28.8-7-83 18.2-114.3m109 31.8c-29 75.7-10.4 88.5 4 129.6l-2-6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#204c00",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M424 14.2c-56 10.4-318.5 40-376.8 235-17 66-7.5 155.6 68.5 152.3 5.3-.2 6 1.5 7.8 6 31.3 74 108.2 60.6 125.5 31.6 2.5-4-3.7-2.2 0 0 78.3 54 121-20.2 145.7-86.4 30.2-57.4 48.6-296.4 32.5-281-275 263.4-274.3 31.5-3.2-57"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    d: "M123.5 402.8c-19.8-90 3.4-105.7 12.4-130M248 437c-25.7-54.2-21.4-99-3.2-132.3"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M352 429.6c.1-2.3-22.7 7.3-22.4 18.2 4-5.2 7.8-5.6 14.2-3 4.6 4.3-9.2-3.6 8.1-15.2z",
    transform: "matrix(10 0 0 10 -3227.7 -4233.9)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidori);
export default __webpack_public_path__ + "static/media/midori.fcb6d6bd8cc95f7099b0c2d51b783cfd.svg";
export { ForwardRef as ReactComponent };